import checkmateApi from '../axios/checkmateApi';
import { IDataSource } from '../slices/dataSourceSlice';

export const getDataSourceList = async (): Promise<{ data: IDataSource[] }> => {
    const response = checkmateApi({
        method: 'GET',
        url: `datasources`
    });
    return response;
};
